import { Navigate, Outlet } from 'react-router-dom';

import { RouteMap } from '@common/constants/RouteMap';

import { usePartnerAuthentication } from '@libs/acp/contexts/PartnerAuthentication';

const PartnerPrivateRoutes = () => {
  const { isAuthenticated } = usePartnerAuthentication();

	if (!isAuthenticated) return <Navigate to={{ pathname: RouteMap.SignUpPartnerPartial, search: `${window.location.search}` }} replace />;

  return (<Outlet />);
};

export default PartnerPrivateRoutes;
